export const FONT_WEIGHT = {
  normal: 400,
  medium: 500,
  bold: 600,
} as const;
